import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BhContentCardComponent } from './bh-content-card.component';

@NgModule({
  declarations: [
    BhContentCardComponent
    ],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
  ],
  exports: [
    BhContentCardComponent
  ]
})
export class BhContentCardComponentModule { }
